import { Button } from '@material-ui/core';
import React, { Component } from 'react';
import { OperationStatus, SUBSCRIPTION_INTERVAL } from '../../../Communication/Constants';
import { PATHS } from '../../../Constants';
import { Strings } from '../../../Resources/Strings/i18n';
import DateUtils from '../../../Utils/DateUtils';
import CommonUtils from '../../../Utils/CommonUtils';

import "./PlanPurchaseSummary.scss";
import ic_edit from '../../../Resources/Images/ic_edit.png';
import PlansAction from '../PlansAction';
import { Alert } from 'react-bootstrap';
import CustomSpinner from '../../Spinner/Spinner';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import CryptoJS from 'crypto-js';

class PlanPurchaseSummary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            transactionInfo: JSON.parse(localStorage.getItem("purchaseSummary")).transactionInfo,
            selectedPlanInfo: JSON.parse(localStorage.getItem("purchaseSummary")).selectedPlanInfo,
            isPaymentMethodAvailable: false,
            lastFour: "",
            editPaymentMethod: false,
            allInputsValid: true,
            showEmail: false,
            errorMessage: "",
            errorCase: false,
            subscriptionPaySuccessful: false,
            showSpinner: false,
        }

      this.PlansAction = new PlansAction();
    }

    componentDidUpdate(){
      
    }
    

    componentDidMount(){
        if(this.state.transactionInfo.paymentNeeded && this.props.userAccessTokenInfo.userId){
            this.getPaymentMethods(this.props.userAccessTokenInfo.userId);
        }

        // console.log('this.props.history',this.props.history)
        const createPaymentMethodInfo = this.props.history.location.state;
        if(createPaymentMethodInfo && createPaymentMethodInfo.paymentMethod) {
          this.setState({
            isCardAdded: true,
            lastFour: createPaymentMethodInfo.paymentMethod.card.last4,
            paymentMethodId: createPaymentMethodInfo.paymentMethod.id,
            isPaymentMethodAvailable: true
          });
        }
        else {
          this.setState({
            isCardAdded: false,
            lastFour: null,
            paymentMethodId: null,
            isPaymentMethodAvailable: false,
          });
        }
    }

    renderPurchaseSummary(){
        let termLength = Strings("Annual");
        let planName = "-";

        if (this.state.selectedPlanInfo && this.state.selectedPlanInfo.plan_name) {
            if (this.state.selectedPlanInfo.plan_name.includes('Yearly')) {
              planName = this.state.selectedPlanInfo.plan_name.split('Yearly')[0];
            }
            else if (this.state.selectedPlanInfo.plan_name.includes('Monthly')) {
              planName = this.state.selectedPlanInfo.plan_name.split('Monthly')[0];
            }
            else {
              planName = this.state.selectedPlanInfo.plan_name;
            }
        }

        if(this.state.selectedPlanInfo.interval === SUBSCRIPTION_INTERVAL.MONTHLY) {
            termLength = Strings("Monthly")
        }

        let formattedStartDate = DateUtils.convertDateFormatToLocalTimezone(this.state.transactionInfo.transactionCreatedAt, "MMM DD, YYYY")

        let autoRenewalText = Strings("Off")
        if (this.state.transactionInfo.autoRenewal) {
            autoRenewalText = Strings("On")
        }

        return (
          <div className="purchaseSummaryContainer">
            <h6 className="purchaseSummaryHeader">Upgrade / Purchase Summary</h6>
            <div className="purchaseSummaryInnerContainer">
              <div className="purchaseSummaryTitleContainer">
                <h6 className="purchaseSummaryTitleText">{Strings("Name")}</h6>
                <h6 className="purchaseSummaryValue">
                  {planName}
                </h6>
              </div>
              <div className='purchaseSummaryDivider'></div>

              <div className="purchaseSummaryTitleContainer">
                <h6 className="purchaseSummaryTitleText">{Strings("StartDate")}</h6>
                <h6 className="purchaseSummaryValue">
                  {formattedStartDate}
                </h6>
              </div>
              <div className='purchaseSummaryDivider'></div>

              <div className="purchaseSummaryTitleContainer">
                <h6 className="purchaseSummaryTitleText">{"Connection Count"}</h6>
                <h6 className="purchaseSummaryValue">
                  {this.state.selectedPlanInfo.mappingCount}
                </h6>
              </div>
              <div className='purchaseSummaryDivider'></div>

              <div className="purchaseSummaryTitleContainer">
                <h6 className="purchaseSummaryTitleText">{"Term"}</h6>
                <h6 className="purchaseSummaryValue">
                  {termLength}
                </h6>
              </div>
              <div className='purchaseSummaryDivider'></div>

              <div className="purchaseSummaryTitleContainer">
                <h6 className="purchaseSummaryTitleText">{"Auto Renewal"}</h6>
                <h6 className="purchaseSummaryValue">
                  {autoRenewalText}
                </h6>
              </div>
              <div className='purchaseSummaryDivider'></div>

              <div className="purchaseSummaryTitleContainer">
                <h6 className="purchaseSummaryTitleText">{"Total Price"}</h6>
                <h6 className="purchaseSummaryValue">
                {this.state.selectedPlanInfo.currency_symbol}{this.state.selectedPlanInfo.total_amount}
                </h6>
              </div>
              <div className='purchaseSummaryDivider'></div>

              <div className="purchaseSummaryTitleContainer">
                <h6 className="purchaseSummaryTitleText">{"Transaction ID"}</h6>
                <h6 className="purchaseSummaryValue">
                  {this.state.transactionInfo.transactionId}
                </h6>
              </div>
            </div>
          </div>
        );
    }

    addCardClick = () => {
      this.props.history.push(`${PATHS.PLANS}${PATHS.ADD_CARD_DETAILS}`);
    }

    openHyperLink(){
      // console.log(`Hyperlink Clicked!!`);
    }

    handleTermsOfUseClick(){
      // console.log('terms of use Clicked!!');
      window.open('https://allwellapp.com/terms/');
    }

    handlePayClick() {
      let paymentMethodInfo = ""

      if (this.state.existingPaymentMethodInfo) {
        // console.log('existing payment method available -', this.state.existingPaymentMethodInfo);
        paymentMethodInfo = this.state.existingPaymentMethodInfo;
      }
      else if (this.props.history && this.props.history.location && this.props.history.location.state) {
        // console.log( 'create paymentMethod new -', this.props.history.location.state)
        paymentMethodInfo = this.props.history.location.state;
      }
      
      this.subscriptionPay(paymentMethodInfo);
    }

    handleReset() {
      window.location.replace('about:blank');
    }

    handleClose() {
      this.props.cleanUserAccessTokenInfo();
      this.props.cleanPaymentMethodData();

      CommonUtils.handleRedirection("success", this.props.deviceType);

      setTimeout(() => {
        localStorage.clear()
        this.handleReset()
      },2000);
    }

    handleCancelBtnClick(props) {
      props.cleanUserAccessTokenInfo();
      props.cleanPaymentMethodData();
      CommonUtils.handleRedirection("fail", props.deviceType);

      setTimeout(() => {
        localStorage.clear()
        this.handleReset()
      },1500);
    }

    renderMainUI(){
      let showAddCard = false;

      if(this.state.transactionInfo.paymentNeeded && !this.state.isPaymentMethodAvailable){
        showAddCard = true;
      }

      let payButtonText = Strings("Upgrade");

      if(this.state.transactionInfo.paymentNeeded) {
        payButtonText = Strings("Pay");
      }

      let termLength = Strings("Annual")
      if (this.state.interval == SUBSCRIPTION_INTERVAL.MONTHLY) {
          termLength = Strings("Monthly")
      }

      let paymentInfoString = Strings('AndroidSubscriptionInfoMsg', {
        amount: this.state.selectedPlanInfo.currency_symbol + this.state.selectedPlanInfo.total_amount,
        period: termLength,
        connectionCount: this.state.selectedPlanInfo.mappingCount
      });


      return(
        <>
          { !this.state.subscriptionPaySuccessful && 
            <div>
            {this.renderPurchaseSummary()}
            <div className='paymentMethodContainer'>
              { this.state.transactionInfo.paymentNeeded ? this.renderPaymentMethod() : null}
            </div>
            {showAddCard ? (
              <>
                <div className="btnWrapper">
                  <Button className="addCardBtn" onClick={this.addCardClick}>
                    {"Add Card"}
                  </Button>
                </div>
              </>
            ) : (
              <>
                <div className='payBtnMainContainer'>
                  <div className='termOfUseContainer'>
                    <h6 className='byTappingPayMsgText'>{Strings("ByTappingPayMsg")}</h6>
                    <div className='termsOfUseTextContainer' onClick={this.handleTermsOfUseClick}>
                      <h6 className='termsOfUse'>{Strings("TermsOfUse")}</h6>
                    </div>
                  </div>
                </div>
                <div className="btnWrapper">
                  <Button className="addCardBtn" onClick={()=>{this.handlePayClick()}} >
                    {payButtonText}
                  </Button>
                </div>
                <div className="cancelTransactionBtn" onClick={()=>{this.handleCancelBtnClick(this.props)}}>CANCEL</div>
                <div className='paymentInfoTextContainer'>
                  <div className='paymentInfoTextStyle'> {paymentInfoString}
                    <h6 className='paymentInfoHyperLinkTextStyle' onClick={this.handleTermsOfUseClick}>{Strings('TERMSOFUSE')}</h6>
                  </div>
                </div>
              </>
            )}
            </div>
          }
        </>
      );

    }

    renderPostPaymentUI(status) {
      let paymentSuccessfulSubText = `Please Close this tab and Relogin to AllWell App!`

      return (
      <> 
      { status ? 
        <div className='SuccessfulPaymentUiContainer'>
          <Alert variant="success" className="alertMessage">
            {Strings("PaymentSuccessful")}
          </Alert>
          <h6 className='paymentSuccessfulSubText'>{paymentSuccessfulSubText}</h6>
          <div className="btnWrapper">
              <Button className="successOkBtn" onClick={() => {
                this.handleClose();
                }}>
                {"CLOSE"}
              </Button>
          </div>
        </div> 
        : 
        null
      }
      </>
      )
    };

    renderErrorUI = () => {
      return (
        <>
          <div className="errorContainer">
            <Alert variant="danger" className="alertMessage">
              {this.state.errorMessage}
            </Alert>
          </div>
        </>
      );
    };

    renderPaymentMethod() {
      let creditCardNumber = "xxxx-xxxx-xxxx-";

      if (this.state.isCardAdded) {
        creditCardNumber = creditCardNumber + this.state.lastFour
      }
      else if (this.props.existingPaymentInfo) {
        if (
          this.props.existingPaymentInfo.paymentMethods && 
          this.props.existingPaymentInfo.paymentMethods.length > 0 && 
          this.props.existingPaymentInfo.paymentMethods[0].card) 
          {
          let lastFourDigits = this.props.existingPaymentInfo.paymentMethods[0].card.last4;
          creditCardNumber = "xxxx-xxxx-xxxx-" + lastFourDigits;
        }
      }
      if(this.state.isPaymentMethodAvailable) {
        return (
          <>
          <div className='existingPaymentMethodContainer'>
            <div>
              <h6 className='paymentMethodTitle'>{Strings("PaymentMethod")}</h6>
              <h6 className='paymentMethodText'>{creditCardNumber}</h6>
            </div>
            <Button onClick={this.addCardClick}>
              <img src={ic_edit} alt={"editPaymentMethod"}/>
            </Button>
          </div>
          <div className='paymentMethodDivider'></div>
          </>
        );
      }
    }
    
    subscriptionPay(paymentMethodInfo){
      this.setState({ showSpinner: true});
      let paymentMethodId = undefined
      let cardNo = undefined
      let expiryMonth = undefined
      let expiryYear = undefined
      let cvv = undefined
      let name = undefined
      let email = undefined

      if (this.state.transactionInfo.paymentNeeded) {
        name = paymentMethodInfo.name;
        email = paymentMethodInfo.email
      }

      if (this.state.editPaymentMethod) {
        cardNo = '';
        cvv = '123';
        expiryMonth = paymentMethodInfo.card.exp_month;
        expiryYear = paymentMethodInfo.card.exp_year;
      }
      else {
        if (this.state.isCardAdded) {
          paymentMethodId = this.state.paymentMethodId;
        }
        else {
          paymentMethodId = paymentMethodInfo.id;
        }
      }

      let requestData = {
        transactionId: this.state.transactionInfo.transactionId,
        planId: this.state.selectedPlanInfo.plan_id,
        paymentMethodId: paymentMethodId,
        cardNo: cardNo,
        expiryMonth: expiryMonth,
        expiryYear: expiryYear,
        cvv: cvv,
        name: name,
        email: email,
      }

      this.PlansAction.subscriptionPay(requestData, async (actionCallback) => { 
        if (actionCallback.status === OperationStatus.SUCCESS) {
          // console.log('Pay API response :-> ', actionCallback.data.data);
          /*if (actionCallback.data.data && actionCallback.data.data.transaction_status === "SUCCESS") {
            localStorage.clear()
            this.setState( { subscriptionPaySuccessful: true, showSpinner: false});
          }*/
          if (actionCallback.data.data && actionCallback.data.data.subscription && actionCallback.data.data.transaction_status === "SUCCESS") {
            let response = await this.handlePaymentThatRequiresCustomerAuthentication(actionCallback.data.data.subscription);
            if (response && response.payment_status === 'success') {
              // console.log('Customer Authentication Successful');
              localStorage.clear();
              this.setState({subscriptionPaySuccessful: true, showSpinner: false });
            }
            else if (response && response.payment_status === 'failure') {
              // console.log('Customer Authentication Failure', response);
              // If the Payment Customer Authentication is failed please unsubscribe the subscription and redirect to plan selection screen.
              let subscriptionId = actionCallback.data.data.subscription && actionCallback.data.data.subscription.id;
              this.PlansAction.unsubscribe(subscriptionId, (actionCallback) => {
                if (actionCallback.status === OperationStatus.SUCCESS) {
                  this.setState({  
                    showSpinner: false,
                  }); 
                }
              });

              // Redirect to Plan Selection Screen, so that user can subscribe to the plan again.
              this.setState({showSpinner: false, errorCase: true, errorMessage: `${response.error.error.message}. Redirecting to plan selection page...`});
              setTimeout(()=> {
                try {
                  let encryptedSecretKey = CryptoJS.AES.encrypt(process.env.REACT_APP_SUBSCRIPTION_KEY,process.env.REACT_APP_SUBSCRIPTION_KEY).toString();
                  let finalEncryptedSecretKey = encryptedSecretKey.split('/').join('atman123').split('+').join('allwell123');

                  let userId = this.props.userAccessTokenInfo && this.props.userAccessTokenInfo.userId;
                  let deviceType = this.props.deviceType;
                  this.props.history.push(`/upgrade/${userId}/${deviceType}/${finalEncryptedSecretKey}`);

                  this.props.cleanUserAccessTokenInfo();
                  this.props.cleanPaymentMethodData();
                } catch (error) {
                  // console.log('Error: Redirecting Failure');
                }
              },5000)
            }
          }
        } else {
          this.setState({
            showSpinner: false,
            subscriptionPaySuccessful: false,
            errorCase: true,
            errorMessage: actionCallback.error.errorMessage,
          });
          // console.log("Error: fetching product plan information gone wrong -!",
          //   actionCallback.error.errorMessage
          // );
        }
      });
    }

    handlePaymentThatRequiresCustomerAuthentication = async (subscription) => {
      if (subscription && subscription.status === 'active') {
        // console.log('Subscription Status: Already Active');
        return {payment_status: 'success', data: subscription};
      }

      let paymentIntent = subscription.latest_invoice.payment_intent;
      if (paymentIntent.status === 'requires_action') {
        // console.log('Payment Intent Status: Requires Action');
        let confirmationStatus = await this.props.stripe.confirmCardPayment(paymentIntent.client_secret,{payment_method: paymentIntent.payment_method})
        if (!confirmationStatus) {
          // console.log('No Confirmation Status Found!', confirmationStatus);
          return {payment_status: 'failure'}
        }
        else if (confirmationStatus && confirmationStatus.paymentIntent) {
          if (confirmationStatus.paymentIntent.status === 'succeeded') {
            // console.log('Success: Payment Intent Status:', confirmationStatus.paymentIntent.status);
            return { payment_status: 'success', data: confirmationStatus};
          }
        }
        else {
          // console.log('Error: Payment Intent Status:', confirmationStatus);
          return { payment_status: 'failure', error: confirmationStatus};
        }
      }
      else if (paymentIntent.status === 'requires_payment_method') {
        // console.log('Payment Intent Status: Requires Payment Method!', paymentIntent)
        let errorObject =  { error: { message: 'Your card was declined'}, status: 'requires_payment_status'};
        return {payment_status: 'failure', error: errorObject}
      }
      else {
        return {payment_status: 'success', data: subscription };
      }
    }
    getPaymentMethods (userId) {
      this.PlansAction.getPaymentMethods(userId,(actionCallback) => {

        if (actionCallback.status === OperationStatus.SUCCESS) {
          // console.log('PaymentMethods -> ', actionCallback.data.data.paymentMethods);
          if (actionCallback.data.data.paymentMethods && actionCallback.data.data.paymentMethods.length !== 0) {
            this.setState({
              existingPaymentMethodInfo: actionCallback.data.data.paymentMethods[0],
              isPaymentMethodAvailable : true 
            });  
          }
        }
        else {
          this.setState({errorCase: true, errorMessage: actionCallback.error.errorMessage });
        }
      });
    }

    render() {
        return (
          <>
            {/* {this.state.errorCase && this.renderErrorUI()} */}
            { (!this.state.subscriptionPaySuccessful && this.state.errorCase) ? this.renderErrorUI() : this.renderMainUI()}
            { (this.state.subscriptionPaySuccessful && !this.state.errorCase) && this.renderPostPaymentUI("SUCCESS")}
            <CustomSpinner showModal={this.state.showSpinner}></CustomSpinner>
          </>
        );
    }
}
function mapStateToProps(state) {
  return {
   userAccessTokenInfo: state.UpgradeHandler.userAccessTokenInfo,
   existingPaymentInfo: state.Plans.existingPaymentInfo,
   deviceType: state.Plans.createTransactionResponse.data[0].device_type,
  };
}


function matchDispatchToProps(dispatch) {
  return {
    cleanUserAccessTokenInfo: () => dispatch({ type: 'CLEAN_USER_ACCESS_TOKEN_DATA' }),
    cleanPaymentMethodData: () => dispatch({ type: 'CLEAN_PAYMENT_METHOD_DATA' }),
  }
}

export default withRouter(
  connect(mapStateToProps, matchDispatchToProps)(PlanPurchaseSummary)
);